import { render, staticRenderFns } from "./ManageExtraCreditsComponent.vue?vue&type=template&id=746c0b1f&scoped=true&"
import script from "./ManageExtraCreditsComponent.vue?vue&type=script&lang=js&"
export * from "./ManageExtraCreditsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746c0b1f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('746c0b1f')) {
      api.createRecord('746c0b1f', component.options)
    } else {
      api.reload('746c0b1f', component.options)
    }
    module.hot.accept("./ManageExtraCreditsComponent.vue?vue&type=template&id=746c0b1f&scoped=true&", function () {
      api.rerender('746c0b1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dancers/credits/components/ManageExtraCreditsComponent.vue"
export default component.exports